<template>
  <section class="relative">
    <div class="container">
      <div class="grid grid-cols-1">
        <div class="bg-[#f1f1f1] h-[1px] w-full block mx-auto"></div>
      </div>
    </div>
  </section>
</template>
